import { call, put } from 'redux-saga/effects'
import { apiConfig } from '../../../../../config/api-config'
import { makeAccess } from '../../../../../config/factory-controller'
import type { ChangePasswordRequest } from '../../../domain/models/reset-password'
import { ChangePasswordService } from '../../../service/change-password-service'
import * as action from '../actions/reset-password-actions'

export const changePasswordResetController = async (payload: { params: ChangePasswordRequest; jwtToken?: string }) => {
  const { key, token } = await makeAccess()
  const dataSource = new ChangePasswordService(apiConfig(key, token))
  
  // Convert para o formato esperado pelo service existente
  const changePasswordPayload = {
    userId: payload.params.UserId,
    currentPassword: '', // Reset não precisa de senha atual
    newPassword: payload.params.NewPassword,
    confirmationNewPassword: payload.params.ConfirmationNewPassword,
  }
  
  const result = await dataSource.create(changePasswordPayload, payload.jwtToken)
  
  return result
}

export function* changePasswordResetSaga({ payload }: any): any {
  try {
    const result = yield call(changePasswordResetController, payload)
    if (result.success) {
      yield put(action.changePasswordResetSuccess(result))
    } else {
      yield put(action.changePasswordResetError(result.message))
    }
  } catch (error: any) {
    yield put(action.changePasswordResetError(error.toString()))
  }
}